<template>
  <div>
    <md-dialog :md-active.sync="showDialog" v-on:md-closed="closed">
      <div class="content-dialog">
        <div class="loading-overlay" v-if="!loadDialog">
          <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <md-dialog-title>Редактирование кассы</md-dialog-title>
        <form novalidate class="md-layout">
          <md-card class="md-layout-item">
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('name')">
                    <label for="cash_name">Название</label>
                    <md-input name="cash_name" id="cash_name" autocomplete="given-name" v-model="form.name" required maxlength="255"/>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">

              <div class="md-layout-item ">
                <md-field>
                  <md-tooltip v-if="this.isOperdayActive">Изменение типа кассы возможно только после закрытия смены на ней. <br/>Сейчас смена активна.</md-tooltip>
                  <label for="cash_type">Тип кассы</label>
                  <md-select v-model="form.type_id" name="type_id" id="type_id" @md-selected="changeCashFilter" md-dense required :disabled="(this.isOperdayActive !== false )">
                    <md-option v-for="v in cashTypes"
                               :value="v.value"
                               :key="v.value">{{ v.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('gender')">
                    <label for="mviza_id">QR mvizaID</label>
                    <md-input name="mviza_id" id="mviza_id" autocomplete="family-name" v-model="form.mviza_id" maxlength="16"/>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field>
                    <label for="mviza_name">QR Mviza merchantName</label>
                    <md-input name="mviza_name" id="mviza_name" autocomplete="family-name" v-model="form.mviza_name" maxlength="255"/>
                  </md-field>
                </div>
              </div>

              <md-field>
                <label for="mviza_category_id">QR Mviza category ID</label>
                <md-input name="mviza_category_id" id="mviza_category_id" autocomplete="family-name" maxlength="16"
                          v-model="form.mviza_category_id"/>
              </md-field>

              <md-field>
                <label for="mviza_terminal_id">QR Mviza terminal ID</label>
                <md-input name="mviza_terminal_id" id="mviza_terminal_id" autocomplete="family-name" maxlength="16"
                          v-model="form.mviza_terminal_id"/>
              </md-field>
            </md-card-content>
          </md-card>
        </form>
        <md-dialog-actions>
          <md-button class="md-primary ct-yellow pointer" @click="showDialog = false">Закрыть</md-button>
          <md-button class="md-primary ct-green pointer" @click="submitForm">Сохранить</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import HttpClient from '@/api/calls'
import Responses from '@/api/responses'
export default {
  name: 'EditCashDialog',
  mixins: [validationMixin],
  data () {
    return {
      form: {
        name: null,
        type_id: null,
        mviza_id: null,
        mviza_name: null,
        mviza_category_id: null,
        mviza_terminal_id: null
      },
      cashType: null,
      items: [],
      cashSaved: false,
      sending: false,
      showDialog: false,
      loadDialog: false,
      isOperdayActive: false,
      cashData: {},
      cashTypes: {},
      cashTypesKZ: [
        { value: '2', name: 'Light касса' },
        { value: '3', name: 'EasyShop касса (без фискализации)' } ],
      cashTypesRU: [
        { value: '1', name: 'Azur POS' },
        { value: '3', name: 'EasyShop касса (без фискализации)' }
      ]
    }
  },
  validations: {
    form: {}
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    submitForm () {
      this.startLoading()

      for (let i in this.form) {
        this.cashData[i] = this.form[i]
      }
      this.successSave = true
      HttpClient.httpPatch(['cash.edit', this.$store.state.shopId, this.$store.state.editId], this.cashData)
        .then(() => {
          Responses.successRspMessage('Выполнено успешно', 'Сохранение')
          this.stopLoading()
        })
        .catch(err => {
          this.stopLoading()
          console.log(err)
        })
    },
    clearForm () {
      this.$v.$reset()
      for (let i in this.form) {
        this.form[i] = null
      }
    },
    setCashInfo (response) {
      this.form.name = response.name
      this.form.type_id = response.type_id
      this.form.mviza_id = response.meta.mviza.id
      this.form.mviza_name = response.meta.mviza.name
      this.form.mviza_category_id = response.meta.mviza.category_id
      this.form.mviza_terminal_id = response.meta.mviza.terminal_id
      this.cashData = response
    },
    getEditData () {
      this.startLoading()
      let params = {}
      params['include'] = 'meta.mviza'
      return HttpClient.httpGet([ 'cash.getById', this.$store.state.shopId, this.$store.state.editId ], params)
    },
    changeCashFilter () {
      this.$emit('changeCashFilter')
    },
    startLoading () {
      this.loadDialog = false
    },
    stopLoading () {
      this.loadDialog = true
    },
    setIsActiveOperday (operday) {
      this.isOperdayActive = operday
    },
    closed () {
      if (this.successSave === true) {
        this.$emit('closeDialogSuccess')
      } else {
        this.$emit('closeDialog')
      }
      this.successSave = false
    }
  },
  async created () {
    this.startLoading()
    if (!this.$store.state.editId) {
      this.showDialog = false
      return false
    }
    if (this.$store.state.filtersCash.country_code === 'ru') {
      this.cashTypes = this.cashTypesRU
    } else {
      this.cashTypes = this.cashTypesKZ
    }
    this.showDialog = true
    const $this = this
    let response = await Promise.all([$this.getEditData()])
    this.setCashInfo(response[0][0])
    this.setIsActiveOperday(response[0]['operday'])

    this.stopLoading()
  }
}
</script>

<style lang="scss" scoped>
  .md-dialog {
    min-width: 25%;
    min-height: 60%;
    overflow: auto;
  }

  .md-tooltip{
    max-width: 500px;

  }
  .md-card {
    margin: 5px 0 0 0;
    overflow: unset;
  }
  .loading-overlay {
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 450px;
    background: none;
    position: absolute;
    z-index: 9;
  }

  .md-button.ct-green {
    background-color: green !important;
  }

  .md-button.ct-yellow {
    background-color: #e29641 !important;
  }

  .pointer {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/cashbox/CashEdit.vue